<template>
  <div class="bottom-banner">
    <span class="bottom-banner__title">{{ title }}</span>
    <b-main class="bottom-banner-subscribe-btn" :title="$t('jobAlert.subscribe')" @click="$emit('click')" />
  </div>
</template>

<script>
import MainButton from '../button/mainButton'

export default {
  components: {
    'b-main': MainButton,
  },
  props: {
    title: {
      default: '',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.bottom-banner {
  @apply flex flex-row items-center;
  @apply py-1 px-3;
  @apply bg-violet-50;
  @apply z-2 border border-violet-100;
  &::v-deep .b.b--main {
    @apply shadow-none text-red;
    background-color: transparent;
    height: 40px;
  }
}
.bottom-banner__title {
  @apply flex-1 min-w-0;
  @apply text-cbody2 font-cbody2 text-grey-600;
  @apply text-left whitespace-pre-wrap;
  @apply mr-2;
}
.bottom-banner-subscribe-btn >>> .b__title {
  @apply text-violet-500;
}
</style>
